import { Row, Typography, Col, Card, Button } from "antd";
import { useTranslation } from "react-i18next";
const CreateFromTemplateCard = () => {
    const { t } = useTranslation();
    return (
        <Card
            bordered={true}
            style={{
                width: "100%",
                borderRadius: "10px",
                marginTop: "20px",
            }}>
            <Row>
                <Col xs={24} s={24} md={24} lg={12} xl={12}>
                    <img src="/template-create.png" style={{ width: "90%" }} />
                </Col>
                <Col
                    xs={24}
                    s={24}
                    md={24}
                    lg={12}
                    xl={12}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                    }}>
                    <div>
                        <Row>
                            <Typography.Text
                                style={{
                                    fontSize: "medium",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                }}>
                                {t("builder.create.templates.title")}
                            </Typography.Text>
                        </Row>
                        <Row
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "10px",
                            }}>
                            {t("builder.create.templates.subtitle")}
                        </Row>
                    </div>
                    <Row
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "20px",
                        }}>
                        <a href="create/templates" style={{ width: "100%" }}>
                            <Button type="primary" style={{ width: "100%" }} size="large">
                                {t("builder.create.templates.call_to_action")}
                            </Button>
                        </a>
                    </Row>
                </Col>
            </Row>
        </Card>
    );
};

export { CreateFromTemplateCard };
